// extracted by mini-css-extract-plugin
export default {"ideasTable":"IdeasTable_ideasTable__5SIW0"};